import Vue from "vue";
import VueResource from "vue-resource";
import { RoundRobinApiSelector } from "./modules/select-api/select_api";
import {
  ModelResource,
  PostLikeResource,
  PostOptionResource,
  ClaimResource,
  UserResource,
  CommentsResource,
  WebstarsResource,
  ChatResource,
  ReportResource,
  BannerResource
} from "./modules/rest/RestResource";

Vue.use(VueResource);
const writeBaseAPIs = process.env.VUE_APP_ROOT_API_WRITE.split(";").map((e) =>
  e.replace(/\/+$/, "")
);
const RRApiWrite = new RoundRobinApiSelector(writeBaseAPIs);

const readBaseAPIs = process.env.VUE_APP_ROOT_API.split(";").map((e) =>
  e.replace(/\/+$/, "")
);
const RRApiRead = new RoundRobinApiSelector(readBaseAPIs);

/**
 *
 * @param name string
 * @param methods array [Array de string con los metodos deseados (Tiene que existir en availableMethods)]
 * @returns {*}
 */
const generateRESTResources = (name, methods) => {
  const availableMethods = {
    index: (params) => Vue.http.get(`${RRApiRead.get()}/${name}`, { params }),
    get: (params) => Vue.http.get(`${RRApiRead.get()}/${name}/${params.id}`, { params }),
    apiReadPost: (params) => Vue.http.post(`${RRApiRead.get()}/${name}`, params),
    store: (params) => Vue.http.post(`${RRApiWrite.get()}/${name}`, params),
    update: (params) =>
      Vue.http.put(`${RRApiWrite.get()}/${name}/${params.id}`, params),
    delete: (params) =>
      Vue.http.delete(`${RRApiWrite.get()}/${name}/${params.id}`, {
        body: params,
      }),
    storeAt: (params) =>
      Vue.http.post(`${RRApiWrite.get()}/${name}/${params.id}`, params),
  };

  if (methods === undefined) {
    return availableMethods; //Devolvemos todos
  } else {
    return methods.reduce((a, e) => ((a[e] = availableMethods[e]), a), {}); //Devolvemos solo los que nos solicitan
  }
};

let resources = {
  movieFavorites: generateRESTResources("movie_favorites", ["store", "delete"]),
  movieLikes: generateRESTResources("movie_likes", ["store", "delete"]),
  movieSearchs: generateRESTResources("movie_searchs", ["store"]),
  movieView: generateRESTResources("movie_views", ["store"]),

  /* Resources */
  posts: generateRESTResources("posts", ["index", "get"]),
  banners: BannerResource,
  feeds: generateRESTResources("feeds", ["index"]),
  celebrities: generateRESTResources("celebrities", ["index"]),
  carousel: generateRESTResources("carousels", ["index"]),
  videos: generateRESTResources("videos", ["index", "get"]),
  movies: generateRESTResources("movies", ["index", "get"]),
  models: ModelResource,
  chatModel: generateRESTResources("chat/model", ["apiReadPost"]),
  movieCategories: generateRESTResources("movie_categories", ["index", "get"]),

  countries: generateRESTResources("countries", ["index"]),
  currencies: generateRESTResources("currencies", ["index"]),
  country_subdivisions: generateRESTResources("country_subdivisions", [
    "index",
  ]),

  //promotionalCodes: generateRESTResources('promotional_codes', ['index']),
  //subscriptionPlans: generateRESTResources('subscription_plans', ['index']),
  addons: generateRESTResources("addons", ["index"]),
  purchaseOptions: generateRESTResources("purchase_options", ["index"]),
  promotionalBanners: generateRESTResources("promotional_banners", ["index"]),
  subscriptions: generateRESTResources("subscriptions", ["index", "delete"]),
  unsubscriptionRequests: generateRESTResources("unsubscription_requests", [
    "store",
  ]),
  additionalMembershipOffers: generateRESTResources(
    "additional_membership_offers",
    ["index", "update"]
  ),

  homepageModels: generateRESTResources("models", ["index"]),
  homepageMovies: generateRESTResources("movies", ["index"]),
  homepageMovieCategories: generateRESTResources("homepage_movie_categories", [
    "index",
  ]),

  languages: generateRESTResources("languages", ["index"]),
  payments: generateRESTResources("payments", ["index", "store", "get"]),
  unavailableEmails: generateRESTResources("unavailable_emails", ["index"]),
  unavailableUsernames: generateRESTResources("unavailable_usernames", [
    "index",
  ]),
  unfinishedUsers: generateRESTResources("unfinished_users", ["index"]),

  frequentlyAskedQuestions: generateRESTResources(
    "frequently_asked_questions",
    ["index"]
  ),
  filters: generateRESTResources("filters", ["index"]),
  tokens: generateRESTResources("tokens", ["index", "store"]),
  tokensBalance: generateRESTResources("tokens/balance", ["index"]),
  paylink: generateRESTResources("payment_link", ["index", "get"]),

  likes: generateRESTResources('like', ['store']),
  chatChangeUsername: generateRESTResources('chat/change_username', ['store']),
  chatUpdateEmailNotifications: generateRESTResources('chat/update_email_notifications', ['store']),
  paymentsInovioRetrieveDdc: generateRESTResources('paymentsInovioRetrieveDdc', ['store']),
  videoCallRoom: generateRESTResources('video_call_room', ['get', 'storeAt']),

  postLike: PostLikeResource,
  postOption: PostOptionResource,
  claim: ClaimResource,
  comments: CommentsResource,
  user: UserResource,
  webstars: WebstarsResource,
  chat: ChatResource,

  // oneClickPaymentMethodAvailables: generateRESTResources('payments', ['index']),

  /* Resources */
};

export default resources;
